import { useEffect } from "react";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { showToast } from "../../../../components/custom/custom-toast";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { IconCheckSuccess } from "../../../../components/icons/icon-group";
import { STATUS } from "../../../../constants/status";
import { useFetchData } from "../../../../hooks/useFetch";
import { CompaniesResponse } from "../../../../models/response/companies";
import { API_COMPANIES_ROUTER } from "../../../../services/api-config";

interface CompaniesChangeStatusProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  dataObject: CompaniesResponse;
  setRefresh: (value: boolean) => void;
}

export const CompaniesChangeStatus = ({ isOpen, setIsOpen, dataObject, setRefresh }: CompaniesChangeStatusProps) => {
  const { request: fetchDataChangeStatus, baseResponse: responsesChangeStatus } = useFetchData.Post();

  const handleChangeStatus = () => {
    if (!isOpen) return;
    fetchDataChangeStatus({
      endPoint: API_COMPANIES_ROUTER.API_CHANGE_STATUS_COMPANIES(dataObject._id),
      data: {
        status: dataObject.status === STATUS.ACTIVE ? STATUS.INACTIVE : STATUS.ACTIVE,
      },
    });
  };

  useEffect(() => {
    if (!responsesChangeStatus) return;
    if (responsesChangeStatus.status === 200) {
      setIsOpen(false);
      showToast({ message: "Đổi trạng thái thành công!", type: "success" });
      setRefresh(true);
    }
  }, [responsesChangeStatus]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col justify-center items-center">
        <>
          <IconCheckSuccess className="w-16 h-16 mb-3" />
          {dataObject.status === STATUS.ACTIVE ? (
            <label htmlFor="name" className="text-center">
              Bạn có muốn Tạm ngưng hoạt động của công ty
              <span className="text-blue-600 uppercase"> {dataObject.name} </span>
              không?
            </label>
          ) : (
            <label htmlFor="name" className="text-center">
              Bạn có muốn Bật hoạt  động của công ty
              <span className="text-blue-600 uppercase"> {dataObject.name} </span>
              không?
            </label>
          )}
        </>
      </div>
    );
  };
  const footerModal = () => {
    return <ButtonCustom type="button" text="Đồng ý" onClick={handleChangeStatus} />;
  };

  return (
    <ModalCustom
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      titleModal="Thông báo"
      bodyModal={bodyModal()}
      footerModal={footerModal()}
      modalSize="40%"
    />
  );
};
